<template>
  <component :is="invoiceData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="invoiceData === undefined">
      <h4 class="alert-heading">獲取發票數據時出錯</h4>
      <div class="alert-body">
        找不到相關發票記錄。請查看
        <b-link class="alert-link" :to="{ name: 'invoices-list' }">
          發票列表
        </b-link>
      </div>
    </b-alert>
    <invoice-edit-tab-information
      v-if="invoiceData"
      :quotation-options="quotationOptions"
      :invoice-type-options="invoiceTypeOptions"
      :customer-options="customerOptions"
      :product-options="productOptions"
      :product-unit-options="productUnitOptions"
      :invoice-description-options="invoiceDescriptionOptions"
      :pdf-remark-options="pdfRemarkOptions"
      :invoice-data="invoiceData"
      :project-options="projectOptions"
      :template-options="templateOptions"
      :product-categories-options="productCategoriesOptions"
      :stamp-options="stampOptions"
      :receipt-description-options="receiptDescriptionOptions"
      @refetch-data="refetchData"
      class="p-sm-2"
    />

    <!-- @refetch-data="refetchData" -->
  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import invoiceStoreModule from "../invoiceStoreModule";
import invoiceEditTabInformation from "./invoiceEditTabInformation.vue";
import axiosIns from "@/libs/axios";
import {getDateTime} from "@/libs/helper";

export default {
  components: {
    invoiceEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  setup() {
    const invoiceData = ref({ 
      id: 0,
      stamp_id: null,
      template_id: 1,
      cost_items: [{ id: 0 }],
      quotation_id:null,
      amount: 0,
      project_id: null,
      coupon_id: null,
      remark:null,
      remark_id:2,
      invoice_description_id:null,
      invoice_remark:null,
      gift_voucher_id: null,
      project_name: null,
      address: null, }
    );
    const invoice = {
      id: 0,
      stamp_id: null,
      template_id: 1,
      cost_items: [{
        id: 0,
        amount: 0,
        invoice_id: null,
        item_description: "",
        product: null,
        product_category_id: null,
        product_id: null,
        quantity: 0,
        sort_order: 1,
        total_amount: 0,
        unit_price: 0
      }],
      payment_steps_title: "付款安排",
      payment_steps: [{
        id: 0,
      }],
      quotation_id:null,
      amount: 0,
      project_id: null,
      coupon_id: null,
      remark_id:2,
      invoice_remark:null,
      empty_rows:0,
      gift_voucher_id: null,
      project_name: null,
      address: null,
    };

    const invoice_APP_STORE_MODULE_NAME = "invoice";

    if (!store.hasModule(invoice_APP_STORE_MODULE_NAME))
      store.registerModule(invoice_APP_STORE_MODULE_NAME, invoiceStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(invoice_APP_STORE_MODULE_NAME))
        store.unregisterModule(invoice_APP_STORE_MODULE_NAME);
    });

    const refetchData = () => {
      if (router.currentRoute.name == "invoice-create") {
        if (router.currentRoute.query.quotation_id) {
          getFetchQuotation(router.currentRoute.query.quotation_id)

        } else {
          invoiceData.value = invoice;
          
          // 處理來自客戶列表的客戶ID query參數
          if (router.currentRoute.query.customer_id) {
            invoiceData.value.customer_id = parseInt(router.currentRoute.query.customer_id);
          }
        }
          // invoiceData.value.remark_id = 2;
          // invoiceData.value.invoice_description_id = 1;
      } else if (router.currentRoute.name == "invoice-copy") {
        // 複製模式：載入原發票資料但重設關鍵欄位以建立新發票
        store
          .dispatch("invoice/fetchInvoice", {
            id: router.currentRoute.params.id,
          })
          .then((response) => {
            const originalInvoice = response.data.invoice;
            invoiceData.value = {...originalInvoice};

            // 重設ID為0以確保建立新發票
            invoiceData.value.id = 0;

            // 清除發票編號，讓系統自動生成新編號
            invoiceData.value.invoice_number = '';

            // 重設日期為今天
            invoiceData.value.invoice_date = getDateTime(new Date(), 1);

            // 重設付款相關欄位
            invoiceData.value.total_paid = 0;

            // 處理cost_items的ID
            invoiceData.value.cost_items.forEach((item) => {
              item.id = 0; // 重設cost item ID
              item.quantity = parseFloat(Number(item.quantity).toString());
            });

            // 處理payment_steps的ID
            if (invoiceData.value.payment_steps && Array.isArray(invoiceData.value.payment_steps)) {
              invoiceData.value.payment_steps.forEach((step) => {
                step.id = 0; // 重設payment step ID
              });
            }

            // 清除優惠券和禮券記錄（這些不應該被複製）
            invoiceData.value.coupon_id = null;
            invoiceData.value.gift_voucher_id = null;
            if (invoiceData.value.coupon_discount !== undefined) {
              invoiceData.value.coupon_discount = 0;
            }
            if (invoiceData.value.gift_voucher_discount !== undefined) {
              invoiceData.value.gift_voucher_discount = 0;
            }
          })
          .catch((error) => {
            console.log("error when fetching invoice for copy", error);
            if (error.response.status === 404) {
              invoiceData.value = undefined;
            }
          });
      } else {
        // 編輯模式：載入現有發票資料
        store
          .dispatch("invoice/fetchInvoice", {
            id: router.currentRoute.params.id,
          })
          .then((response) => {
            invoiceData.value = response.data.invoice;
            invoiceData.value.cost_items.forEach(
              (item) => {
                item.quantity = parseFloat(Number(item.quantity).toString());
              }
            );
          })
          .catch((error) => {
            console.log("error when fetching invoice", error);
            if (error.response.status === 404) {
              invoiceData.value = undefined;
            }
          });
      }
    };
    const getFetchQuotation = (id) => {
        axiosIns
          .get(`/quotations/${id}`)
          .then((response) => {
            let data = { ...response.data.quotation };
                data.quotation_id = Number(id);
                data.id = 0;
                data.invoice_type_id = data.quotation_type_id;
                data.invoice_date = getDateTime(new Date(), 1);

                data.cost_items = data.cost_items.map(
                  (item) => {
                    item.id = 0;
                    return item;
                  }
                );

                delete data.quotation_type;
                delete data.quotation_type_id;
                delete data.quotation_remark;
                delete data.quotation_date;
                delete data.quotation_number;

                // 初始化發票專有欄位（報價單沒有這些欄位）
                data.payment_steps = [
                  {
                    id: 0,
                    step_phase: "",
                    step_name: "",
                    step_percentage: 0,
                    step_amount: 0,
                  }
                ];
                data.payment_steps_title = "付款安排";

                // 根據發票類別設定正確的 remark_id（不要直接複製報價單的 remark_id）
                if (data.invoice_type_id == 1) {
                  // 銷售類發票
                  data.remark_id = 2;
                } else {
                  // 維修類發票
                  data.remark_id = 4;
                }

                invoiceData.value = data;
          })
          .catch((error) => {
            console.log("error when fetching quotation", error);
          
          });
    
    }

    const receiptDescriptionOptions = ref([]);
    const invoiceTypeOptions = ref([]);
    const quotationOptions = ref([]);
    const customerOptions = ref([]);
    const productOptions = ref([]);
    const productUnitOptions = ref([]);
    const projectOptions = ref([]);
    const productCategoriesOptions = ref([]);
    const invoiceDescriptionOptions = ref([]);
    const pdfRemarkOptions = ref([]);
    const templateOptions = ref([]);
    const stampOptions = ref([]);

    const refetchOption = () => {
      getQuotationList()
      store
        .dispatch("app/fetchOptionList", {
          quotation_types: true,
          // quotations: true,
          customers: true,
          projects: true,
          products: true,
          product_categories: true,
          product_units: true,
          invoice_descriptions: true,
          invoice_remarks: true,
          templates: true,
          stamps: true,
          receipt_descriptions: true,
        })
        .then((response) => {
          invoiceTypeOptions.value = response.data.quotation_types;
          // quotationOptions.value = response.data.quotations;
          customerOptions.value = response.data.customers;
          projectOptions.value = response.data.projects;
          productOptions.value = response.data.products;
          productCategoriesOptions.value = response.data.product_categories;
          productUnitOptions.value = response.data.product_units;
          invoiceDescriptionOptions.value = response.data.invoice_descriptions;
          pdfRemarkOptions.value = response.data.invoice_remarks;
          templateOptions.value = response.data.templates;
          stampOptions.value = response.data.stamps;
          receiptDescriptionOptions.value = response.data.receipt_descriptions;
          console.log("receiptDescriptionOptions:", receiptDescriptionOptions.value);
          refetchData();
        });
    };


    const getQuotationList = () => {
      axiosIns
          .get(`/quotations/`,{params:{}})
          .then((response) => {
            quotationOptions.value = response.data.quotations
          });
    }


    onMounted(() => {
      refetchOption();
    });

    return {
      invoiceTypeOptions,
      quotationOptions,
      customerOptions,
      productOptions,
      productCategoriesOptions,
      invoiceData,
      refetchData,
      refetchOption,
      productUnitOptions,
      invoiceDescriptionOptions,
      pdfRemarkOptions,
      projectOptions,
      templateOptions,
      stampOptions,
      receiptDescriptionOptions,
    };
  },
};
</script>
